/**
 * @generated SignedSource<<0c28e295db48e2ed4c48d24dc8af5bab>>
 * @relayHash fd4cb6f3571e14ffe0aaedf31344d774
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04b83b613cdd7f5c82d98e9c5ef18e4d689581650254e9b0a7e39ba1cc846859

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { featureOnboardingModalQuery } from './featureOnboardingModalQuery.graphql';

const node: PreloadableConcreteRequest<featureOnboardingModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "04b83b613cdd7f5c82d98e9c5ef18e4d689581650254e9b0a7e39ba1cc846859",
    "metadata": {},
    "name": "featureOnboardingModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
